import { GET, PUT, DELETE, POST } from "constants/methods";

const service = "calendy";
const eventTypes = `/${service}/eventTypes`;

export function getEventTypes() {
  const url = `${eventTypes}`;
  return {
    method: GET,
    url,
  };
}

export function getEventTypesPublicAvailabilities(coachID, filters) {
  const url = `${eventTypes}/${coachID}/publicAvailabilities${filters}`;
  return {
    method: GET,
    url,
  };
}

export function getEventTypeById(id) {
  const url = `${eventTypes}/${id}`;
  return {
    method: GET,
    url,
  };
}

export function updateEventType(id, body) {
  const url = `${eventTypes}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteEventType(id) {
  const url = `${eventTypes}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createEventType(body) {
  const url = `${eventTypes}`;
  return {
    method: POST,
    url,
    body,
  };
}
